import './assets/css/style.css';
import '@fontsource-variable/roboto';

import DirectionProvider from '@elementor/ui/DirectionProvider';
import { createTheme, ThemeProvider } from '@elementor/ui/styles';
import React, { StrictMode, Fragment } from 'react';
import ReactDOM from 'react-dom/client';
import { HeadingStructureContextProvider } from '@context/heading-structure-context';
import InstallModalContextProvider from '@context/install-modal-context';
import ScannerWizardContextProvider from '@context/scanner-wizard-context';
import isRTL from '@utils/rtl';
import App from './app';

const rootNode = document.getElementById('ea11y-scanner-wizard');

if (isRTL()) {
	rootNode.setAttribute('dir', 'rtl');
}

// Can't use the settings hook in the global scope so accessing directly
const isDevelopment = process.env.NODE_ENV === 'development';
const AppWrapper = Boolean(isDevelopment) ? StrictMode : Fragment;

const theme = createTheme({
	direction: isRTL() ? 'rtl' : 'ltr',
});

ReactDOM.createRoot(rootNode).render(
	<AppWrapper>
		<DirectionProvider rtl={isRTL()}>
			<ThemeProvider colorScheme="light" theme={theme}>
				<ScannerWizardContextProvider>
					<HeadingStructureContextProvider>
						<InstallModalContextProvider>
							<App />
						</InstallModalContextProvider>
					</HeadingStructureContextProvider>
				</ScannerWizardContextProvider>
			</ThemeProvider>
		</DirectionProvider>
	</AppWrapper>,
);
